/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */

import { CalendarOutlined, MailOutlined, PhoneOutlined, UserOutlined } from '@ant-design/icons';
import { Tag } from 'antd';
import colors from 'constants/colors';

export default {
  rowKey: 'id',
  displayColumns: [
    {
      title: 'Mã',
      key: 'id',
      width: '1%',
      fixed: 'left',
      render: 'renderNoWrap',
      style: {
        fontWeight: 600,
        color: colors.font,
      },
    },
    {
      title: 'Họ và tên',
      key: 'fullName',
      fixed: 'left',
      width: '1%',
      // render: 'renderNoWrap',
      render: (value) => {
        return (
          <span title={value} className='tw-uppercase tw-truncate tw-inline-block' style={{ color: colors.font, fontWeight: 600, maxWidth: 250 }}>
            <UserOutlined className='tw-mr-2' />
            {value}
          </span>
        );
      },
      // style: {
      //   fontWeight: 600,
      //   textTransform: 'uppercase',
      //   color: colors.font,
      // },
      // prefix: <UserOutlined className='tw-mr-2' />,
    },
    {
      title: 'Loại tài khoản',
      key: 'roleID',
      width: '1%',
      // render: 'renderNoWrap',
      render: (value) => {
        return (
          <Tag color={value === 1 ? 'blue' : 'orange'} style={{ minWidth: 50 }}>
            {value === 1 ? 'Học sinh' : value === 2 ? 'Giáo viên' : ''}
          </Tag>
        );
      },
    },
    {
      title: 'Cấp',
      key: 'schoolTypeId',
      width: '1%',
      // render: 'renderNoWrap',
      render: (value) => {
        return (
          <Tag color={value === 0 ? 'green' : value === 1 ? 'blue' : value === 2 ? 'orange' : value === 3 ? 'red' : ''} style={{ minWidth: 50 }}>
            {value === 0 ? 'Mầm non' : value === 1 ? 'Cấp 1' : value === 2 ? 'Cấp 2' : value === 3 ? 'Cấp 3' : ''}
          </Tag>
        );
      },
    },
    {
      title: 'Email',
      key: 'email',
      width: '1%',
      render: 'renderNoWrap',
      style: {
        fontWeight: '400',
        textTransform: 'lowercase',
        color: colors.font,
      },
      prefix: <MailOutlined className='tw-mr-2' />,
    },
    {
      title: 'Điện thoại',
      key: 'phone',
      render: 'renderNoWrap',
      width: 135,
      style: {
        fontWeight: 400,
        color: colors.font,
      },
      prefix: <PhoneOutlined className='tw-mr-2' />,
    },

    // {
    //   title: 'Loại tài khoản',
    //   key: 'roleId',
    //   render: 'renderExpression',
    //   expression: 'record.roleId === 1 ? "Học sinh" : "Giáo viên"',
    //   width: 135,
    //   style: {
    //     fontWeight: 400,
    //     color: colors.font,
    //   },
    // },

    // {
    //   title: 'Ghi chú',
    //   key: 'description',
    //   render: 'renderText',
    //   soft: false,
    //   style: {
    //     fontWeight: '400',
    //     color: colors.font,
    //   },
    // },
    {
      title: 'Ngày tạo',
      key: 'createdDate',
      width: '1%',
      sort: false,
      render: 'renderDateTime',
      prefix: <CalendarOutlined className='tw-mr-2' />,
    },
  ],
};
